import {type ForwardedRef, forwardRef} from 'react';
import {cn} from '../../../../../lib/classname';

type Props = {
  name: string;
  className?: string;
};

export const ColumnCardCompanyTag = forwardRef<HTMLSpanElement, Props>(
  ({name, className}, ref: ForwardedRef<HTMLSpanElement>) => {
    return (
      <span
        ref={ref}
        className={cn(
          'text-black-2 text-[12px] leading-[18px] border border-black-2 rounded-16 px-8 py-4',
          'text-nowrap',
          className,
        )}
      >
        {name}
      </span>
    );
  },
);
